import { Center, Spinner } from '@chakra-ui/react';

function FullscreenLoading() {
  return (
    <Center
      bgGradient="linear(to-r, brand.darkPurple 7.24%, brand.grayishBlack 115.47%)"
      height="100vh"
    >
      <Spinner color="brand.purple" size="xl" />
    </Center>
  );
}

export default FullscreenLoading;
